// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26Y9d","content":"styles_content__2IVAl","tableWrap":"styles_tableWrap__3tis9"};